/*
 * @Author: tangke
 * @Date: 2019-02-11 18:46:44
 * @Last Modified by: others
 * @Last Modified time: 2019-04-10 15:46:02
 * personalData页面下Submit & Upload部分
 */
<template>
  <v-card color="transparent">
    <v-card-title class="ml-3 pt-4 pl-5">
      <div>
        <h3 class="headline mb-0">Submit&#38;Upload</h3>
      </div>
    </v-card-title>
    <v-card-text class="pt-0">
      <v-container class="person-container pt-0">
        <v-layout row
                  wrap>
          <v-flex lg10
                  class="mb-4"
                  md12
                  xs12>
            <v-layout row
                      wrap>
              <v-flex xs12
                      md6
                      class="padding-add tab-margin-bottom">
                <v-card class="mt-2 mb-4 mx-4"
                        height="100%"
                        flat>
                  <v-card-title class="title-border">
                    <div>
                      <h3 class="title mb-0">Voice Recording<i v-show="!!audioForm.state"
                           class="red--text text--darken-4 body-2">({{audioForm.state}})</i></h3>
                    </div>
                  </v-card-title>
                  <v-card-text class="mt-3">
                    <v-flex xs12
                            md8
                            offset-md2>
                      <v-form>
                        <v-img v-show="!audioForm.fileUrl"
                               class="grey lighten-4  img-border"
                               height="160px">
                          <v-container fill-height
                                       fluid
                                       class="pa-0">
                            <v-layout row
                                      wrap
                                      fill-height>
                              <v-flex fill-height
                                      xs12
                                      class="text-xs-center">
                                <v-btn large
                                       block
                                       depressed
                                       class="ma-0 height-fill  grey--text text--darken-1 text-none"
                                       flat>
                                  <img :src="audioBg"
                                       class="mb-2"
                                       alt="">
                                  <span class="subheading">Add Your Audio</span>
                                </v-btn>
                              </v-flex>
                              <v-flex fill-height
                                      xs12
                                      class="text-xs-center mask-box">
                                <input type="file"
                                       class="upload"
                                       @change="changeVoiceRecording"
                                       ref="inputer"
                                       multiple
                                       id='voiceRecordingFile'
                                       accept="audio/*" />
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-img>
                        <!-- 下地址 audioForm.isUpload为真时请替换为文件上传后的地址 -->
                        <v-img v-show="!!audioForm.fileUrl"
                               class="gray"
                               height="160px">
                          <v-container fill-height
                                       fluid
                                       class="pa-0">
                            <v-layout row
                                      wrap
                                      fill-height
                                      align-center>
                              <v-flex align-center
                                      justify-center
                                      xs12
                                      class="text-xs-center">
                                <!-- 此处请替换为文件上传后的地址 -->
                                <audio class="audio-position"
                                       :src="audioForm.fileUrl"
                                       controls="controls">
                                  您的浏览器不支持 audio 标签。
                                </audio>
                              </v-flex>
                              <v-flex fill-height
                                      xs12
                                      class="text-xs-center mask-box">
                                <input v-show="0"
                                       type="file"
                                       class="upload"
                                       @change="changeVoiceRecording"
                                       ref="inputer"
                                       multiple
                                       id='voiceRecordingFile'
                                       accept="audio/*" />
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-img>
                        <v-card-actions class="mt-3">
                          <v-spacer></v-spacer>
                          <v-btn v-show="!!audioForm.fileUrl"
                                 color="orange  accent-4"
                                 class="text-none white--text font-weight-light"
                                 @click="replaceVoiceRecording">Replace</v-btn>
                          <v-btn color="teal accent-4"
                                 class="text-none white--text font-weight-light"
                                 @click="uploadVoiceRecording">Submit</v-btn>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-form>
                    </v-flex>
                    <div class="mt-3">
                      <label for=""
                             class="d-inline-block subheading font-weight-bold mb-2">Requirement: </label>
                      <ol>
                        <li>Speak in English</li>
                        <li>Around 2-min long</li>
                        <li>The audio file should be in MP3 format</li>
                      </ol>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12
                      md6
                      class="padding-add">
                <v-card class="mt-2 mb-4 mx-4"
                        height="100%"
                        flat>
                  <v-card-title class="title-border">
                    <div>
                      <h3 class="title mb-0">Identity<i v-show="!!identityForm.state"
                           class="red--text text--darken-4 body-2">({{identityForm.state}})</i></h3>
                    </div>
                  </v-card-title>
                  <v-card-text class="mt-3 mx-4">
                    <v-flex xs12
                            md10>
                      <v-form>
                        <div class="d-flex">
                          <label class="subheading fix-flex pt-2 pr-2">ID Number</label>
                          <v-text-field v-model="identityForm.idNumber"
                                        single-line
                                        outline
                                        hide-details
                                        box></v-text-field>
                        </div>
                        <div class="d-flex mt-3">
                          <label class="subheading  fix-flex pr-4 mr-2">ID Card</label>
                          <v-img v-if="!identityForm.fileUrl"
                                 class="grey lighten-4  img-border"
                                 height="180px">
                            <v-container fill-height
                                         fluid
                                         class="pa-0">
                              <v-layout align-center
                                        justify-center
                                        row
                                        fill-height>
                                <v-flex fill-height
                                        xs12
                                        class="text-xs-center">
                                  <v-btn large
                                         block
                                         depressed
                                         class="ma-0 height-fill grey--text text--darken-1 text-none"
                                         flat>
                                    <img :src="idCardBg"
                                         class="mb-2"
                                         alt="">
                                    <span class="subheading">Add Your ID Cards</span>
                                  </v-btn>
                                </v-flex>
                                <v-flex fill-height
                                        xs12
                                        class="text-xs-center mask-box">
                                  <input type="file"
                                         class="upload"
                                         @change="changeIdentity"
                                         ref="inputer"
                                         multiple
                                         id="identityFile"
                                         accept="image/*" />
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-img>
                          <v-img v-if="!!identityForm.fileUrl"
                                 class="white--text"
                                 height="180px"
                                 :src="identityForm.fileUrl">
                            <v-flex fill-height
                                    xs12
                                    class="text-xs-center mask-box">
                              <input v-show="0"
                                     type="file"
                                     class="upload"
                                     @change="changeIdentity"
                                     ref="inputer"
                                     multiple
                                     id="identityFile"
                                     accept="image/*" />
                            </v-flex>
                          </v-img>
                        </div>

                        <v-card-actions class="mt-3">
                          <label class="subheading  fix-flex pr-4 mr-2 white--text">ID Card</label>
                          <v-spacer></v-spacer>
                          <v-btn v-show="!!identityForm.fileUrl"
                                 color="orange  accent-4"
                                 class="text-none white--text font-weight-light"
                                 @click="replaceIdentity">Replace</v-btn>
                          <v-btn color="teal accent-4"
                                 class="text-none white--text font-weight-light"
                                 @click="identity">Submit</v-btn>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-form>
                    </v-flex>
                    <div class="mt-3">
                      <label for=""
                             class="d-inline-block subheading font-weight-bold mb-2">Requirement: </label>
                      <ol>
                        <li>Maximum size of a single file: <span class="red--text">4 MB</span></li>
                        <li>Accepted format: <span class="font-weight-medium">JPG, GIF, PNG</span></li>
                      </ol>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg10
                  md12
                  xs12>
            <v-layout row
                      wrap>
              <v-flex xs12
                      md6
                      class="padding-add tab-margin-bottom">
                <v-card class="mt-2 mb-4 mx-4"
                        height="100%"
                        flat>
                  <v-card-title class="title-border">
                    <div>
                      <h3 class="title mb-0">Photo<i v-show="!!photoForm.state"
                           class="red--text text--darken-4 body-2">({{photoForm.state}})</i></h3>
                    </div>
                  </v-card-title>
                  <v-card-text class="mt-3">
                    <v-flex xs12
                            md8
                            offset-md2>
                      <v-form class="px-4 mx-3">
                        <v-img v-show="!this.photoForm.fileUrl"
                               class="grey lighten-4  img-border"
                               height="180px">
                          <v-container fill-height
                                       fluid
                                       class="pa-0">
                            <v-layout align-center
                                      justify-center
                                      row
                                      fill-height>
                              <v-flex fill-height
                                      xs12
                                      class="text-xs-center">
                                <v-btn large
                                       block
                                       depressed
                                       class="ma-0 height-fill grey--text text--darken-1 text-none"
                                       flat>
                                  <img :src="imgBg"
                                       class="mb-2"
                                       alt="">
                                  <span class="subheading">Add Your Photo</span>
                                </v-btn>
                              </v-flex>
                              <v-flex fill-height
                                      xs12
                                      class="text-xs-center mask-box">
                                <input type="file"
                                       class="upload"
                                       @change="changeAvator"
                                       ref="inputer01"
                                       multiple
                                       accept="image/*" />
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-img>
                        <v-img v-show="!!this.photoForm.fileUrl"
                               class="white--text"
                               height="180px"
                               contain
                               :src="this.photoForm.fileUrl"
                               gradient="to top right, rgba(0,0,0,.12), rgba(0,0,0,.12)"
                               @error="avatorLoadError">
                        </v-img>
                        <v-card-actions class="mt-3">
                          <v-spacer></v-spacer>
                          <v-btn v-show="!!this.photoForm.fileUrl"
                                 color="orange  accent-4"
                                 class="text-none white--text"
                                 @click="replaceAvator">Replace</v-btn>
                          <v-btn color="teal accent-4"
                                 class="text-none white--text"
                                 @click="uploadAvator">Submit</v-btn>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-form>
                    </v-flex>
                    <div class="mt-3">
                      <label for=""
                             class="d-inline-block subheading font-weight-bold mb-2">Requirement: </label>
                      <ol>
                        <li>Maximum size of a single file: <span class="red--text">4 MB</span></li>
                        <li>Accepted format: <span class="font-weight-medium">JPG, GIF, PNG</span></li>
                      </ol>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12
                      md6
                      class="padding-add">
                <v-card class="mt-2 mb-4 mx-4"
                        height="100%"
                        flat>
                  <v-card-title class="title-border">
                    <div>
                      <h3 class="title mb-0">Personal Certificates<i v-show="!!certificatesForm.state"
                           class="red--text text--darken-4 body-2">({{certificatesForm.state}})</i></h3>
                    </div>
                  </v-card-title>
                  <v-card-text class="mt-3">
                    <v-flex xs12
                            md8
                            offset-md2>
                      <v-form class="px-4 mx-3">
                        <v-img v-if="!certificatesForm.fileUrl"
                               class="grey lighten-4  img-border"
                               height="192px">
                          <v-container fill-height
                                       fluid
                                       class="pa-0">
                            <v-layout align-center
                                      justify-center
                                      row
                                      fill-height>
                              <v-flex fill-height
                                      xs12
                                      class="text-xs-center">
                                <v-btn large
                                       block
                                       depressed
                                       class="ma-0 height-fill grey--text text--darken-1 text-none"
                                       flat>
                                  <img :src="pdfBg"
                                       class="mb-2"
                                       alt="">
                                  <span class="subheading">Add Your Certificates</span>
                                </v-btn>
                              </v-flex>
                              <v-flex fill-height
                                      xs12
                                      class="text-xs-center mask-box">
                                <input type="file"
                                       class="upload"
                                       @change="changeCertificates"
                                       ref="inputer"
                                       multiple
                                       id="certificatesFile"
                                       accept=".pdf" />
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-img>
                        <v-img v-if="certificatesForm.fileUrl"
                               class="white--text"
                               contain
                               height="192px"
                               :src="pdfPreview">
                          <v-flex fill-height
                                  xs12
                                  class="text-xs-center mask-box">
                            <input v-show="0"
                                   type="file"
                                   class="upload"
                                   @change="changeCertificates"
                                   ref="inputer"
                                   multiple
                                   id="certificatesFile"
                                   accept=".pdf" />
                          </v-flex>
                        </v-img>
                        <v-card-actions class="mt-3">
                          <v-spacer></v-spacer>
                          <v-btn v-show="!!certificatesForm.fileUrl"
                                 color="orange  accent-4"
                                 class="text-none white--text"
                                 @click="replaceCertificates">Replace</v-btn>
                          <v-btn color="teal accent-4"
                                 class="text-none white--text"
                                 @click="uploadCertificates">Submit</v-btn>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-form>
                    </v-flex>
                    <div class="mt-3">
                      <label for=""
                             class="d-inline-block subheading font-weight-bold mb-2">Tips: </label>
                      <ol class="list-none">
                        <li>Please upload the scan copy in the format of <span class="red--text">PDF</span></li>
                      </ol>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
import { uploadAvator, uploadVoiceRecording, uploadCertificates, identity, getUserCertInfo } from '@/api/teachinfo'
import audioBg from '@/assets/img/person/audio_bg.png'
import idCardBg from '@/assets/img/person/idCard_bg.png'
import imgBg from '@/assets/img/person/img_bg.png'
import pdfBg from '@/assets/img/person/pdf_bg.png'
import pdfPreview from '@/assets/img/person/pdf_preview_bg.png'

export default {
  name: 'Upload',
  data: () => ({
    defaultImg: 'https://cdn.vuetifyjs.com/images/cards/docks.jpg',
    audioForm: {
      fileUrl: '',
      state: '',
      files: []
    },
    audioBg: audioBg,
    idCardBg: idCardBg,
    pdfBg: pdfBg,
    imgBg: imgBg,
    pdfPreview: pdfPreview,
    identityForm: {
      fileUrl: '',
      state: '',
      files: [],
      idNumber: ''
    },
    photoForm: {
      fileUrl: '',
      state: '',
      files: []
    },
    certificatesForm: {
      fileUrl: '',
      state: '',
      files: []
    }
  }),
  async mounted () {
    this.photoForm.fileUrl = this.$store.state.user.avatar
    if (!this.$store.state.fileDomain) {
      console.log('initSystemSetting')
      await this.$store.dispatch('initSystemSetting')
    }
    const domain = this.$store.state.system.fileDomain
    getUserCertInfo().then(res => {
      if (res.data.ErrorCode === 0) {
        let _data = res.data.Body
        this.audioForm.fileUrl = domain + _data.TutorRecord
        this.audioForm.state = _data.TutorRecordState
        this.identityForm.fileUrl = domain + _data.IdentityPic
        this.identityForm.idNumber = _data.Identification
        this.identityForm.state = _data.IdentityPicState
        this.certificatesForm.fileUrl = domain + _data.DiplomaFile
        this.certificatesForm.state = _data.DiplomaFileState
        this.photoForm.state = _data.AvatarState
        console.log(res.data.Body)
      }
    })
  },
  methods: {
    alert (msg) {
      return this.$root.$alertTips(msg, 'success')
    },
    alertError (msg) {
      return this.$root.$alertTips(msg)
    },
    imgLoadError () {

    },
    replaceVoiceRecording () {
      document.getElementById('voiceRecordingFile').click()
    },
    changeVoiceRecording (elemt) {
      this.audioForm.files = elemt.target.files

      if (!this.audioForm.fileUrl) {
        this.audioForm.fileUrl = '1'
      }
      // this.converToBase64(this.audioForm.files[0], 100).then(base64Data => {
      //   this.audioForm.fileUrl = base64Data
      // })
    },
    uploadVoiceRecording () {
      if (this.audioForm.files.length === 0) {
        this.alertError('please check the audioes..')
        return
      }
      let form = new FormData()
      form.append('file', this.audioForm.files[0])
      uploadVoiceRecording(form).then(res => {
        if (res.data.ErrorCode === 0 && res.data.Body.fileUrl) {
          this.audioForm.fileUrl = res.data.Body.fileUrl
        }

        let type = res.data.ErrorCode === 0 ? 'success' : 'error'
        this.$root.$alertTips(res.data.Msg, type).then(() => {

        })
      })
    },
    identity () {
      if (this.identityForm.files.length === 0) {
        this.alertError('please check the identity...')
        return
      }
      let form = new FormData()
      form.append('file', this.identityForm.files[0])
      form.append('idNumber', this.identityForm.idNumber)
      identity(form).then(res => {
        let type = res.data.ErrorCode === 0 ? 'success' : 'error'
        this.$root.$alertTips(res.data.Msg, type).then(() => {
          // this.alert(res.data.Msg).then(() => {

        })
      })
    },
    replaceIdentity () {
      document.getElementById('identityFile').click()
    },
    changeIdentity (elemt) {
      this.identityForm.files = elemt.target.files
      this.converToBase64(this.identityForm.files[0]).then(base64Data => {
        this.identityForm.fileUrl = base64Data
      })
    },
    replaceAvator () {
      this.$refs.inputer01.click()
      // document.getElementById('avatorFile').click()
    },
    changeAvator (elemt) {
      this.photoForm.files = elemt.target.files
      this.converToBase64(this.photoForm.files[0]).then(base64Data => {
        this.photoForm.fileUrl = base64Data
      })
    },
    uploadAvator () {
      if (this.photoForm.files.length === 0) {
        this.alertError('please check the photo...')
        return
      }
      let form = new FormData()
      form.append('file', this.photoForm.files[0])
      uploadAvator(form).then(res => {
        let type = res.data.ErrorCode === 0 ? 'success' : 'error'
        this.$root.$alertTips(res.data.Msg, type).then(() => {
          // this.alert(res.data.Msg).then(() => {
          if (res.data.ErrorCode === 0) {
            this.$store.dispatch('UpdateActar', res.data.Body.imgUrl)
          }
        })
      })
    },
    avatorLoadError () {
      this.photoForm.fileUrl = this.$store.state.user.defaultAvatar
    },
    replaceCertificates () {
      document.getElementById('certificatesFile').click()
    },
    changeCertificates (elemt) {
      this.certificatesForm.files = elemt.target.files
      if (!this.certificatesForm.fileUrl) {
        this.certificatesForm.fileUrl = '1'
      }
      // this.converToBase64(this.certificatesForm.files[0], 50).then(base64Data => {
      //   this.certificatesForm.fileUrl = base64Data
      // })
    },
    uploadCertificates (e) {
      if (this.certificatesForm.files.length === 0) {
        this.alertError('please check the certifycates...')
        return
      }
      let form = new FormData()
      form.append('file', this.certificatesForm.files[0])
      uploadCertificates(form).then(res => {
        let type = res.data.ErrorCode === 0 ? 'success' : 'error'
        this.$root.$alertTips(res.data.Msg, type).then(() => {
          // this.alert(res.data.Msg).then(() => {

        })
      })
    },
    converToBase64 (file, maxSize) {
      return new Promise((resolve, reject) => {
        var AllowImgFileSize = (maxSize || 4) * 1024 * 1024 // 上传图片最大值(单位字节)（ 2 M = 2097152 B ）超过2M上传失败
        if (file) {
          resolve(window.URL.createObjectURL(file))
          // if (AllowImgFileSize !== 0 && AllowImgFileSize < reader.result.length) {

          // } else {
          //   // 执行上传操作
          //   reject('上传失败，请上传不大于' + (maxSize || 4) + 'M的图片！')
          // }
        } else {
          reject(new Error('file is empty'))
        }
      })
    }
  }
}
</script>
<style>
.height-fill .v-btn__content {
  flex-direction: column;
}
</style>
<style lang="sass" scoped>
@import './upload'
</style>
